export function initDownload() {
  const download = document.querySelector("#js-download");
  if (download) {
    setTimeout(() => {
      download.querySelector("a").click();
    }, 1000);
  }
}
